module.exports = __webpack_public_path__ + "static/media/covid1.c8eefdcc.png";